"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var buttonSpan = {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
};
exports.buttonSpan = buttonSpan;
var container = {
    display: 'flex',
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
};
exports.container = container;
var input = {
    width: '100%',
};
exports.input = input;
var inputContainer = {
    flexGrow: 1,
};
exports.inputContainer = inputContainer;
var button = {
    paddingLeft: '8px',
    paddingRight: '8px',
    marginLeft: '-1px',
    alignSelf: 'flex-end',
    borderRadius: '1px',
};
exports.button = button;
var primaryButton = __assign({}, button, { borderColor: widgets_1.TabStyles.Colors.L6 });
exports.primaryButton = primaryButton;
var icon = {
    marginRight: '8px',
};
exports.icon = icon;
var label = {
    display: 'block',
    color: '#4F4F4F',
    marginBottom: '4px',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
};
exports.label = label;
//# sourceMappingURL=ShareLinkStyle.js.map